import { Box, styled } from '@mui/material';
import { Tbooleanish } from 'types/booleanish.types';

/**
 * Styled Box which already uses flex styles and centers the content
 */
const FlexBox = styled(Box)<{
  alignItems?: 'center' | 'flex-start' | 'flex-end' | 'normal';
  backgroundColor?: string;
  clickable?: Tbooleanish;
}>(({ alignItems = 'center', clickable, backgroundColor }) => ({
  display: 'flex',
  alignItems,
  cursor: clickable === 'true' ? 'pointer' : 'default',
  backgroundColor,
}));

export default FlexBox;
